import { __awaiter, __generator } from "tslib";
import statementModal from "@/components/statementModal";
import store from "@/store";
import { tc } from "@/utils/language";
import api from "@/api";
export default (function (statementType, title, callback) {
  return __awaiter(void 0, void 0, void 0, function () {
    var item;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, store.dispatch("user/getSignAgreement", statementType)];

        case 1:
          item = _a.sent();

          if (item) {
            statementModal({
              url: item.file_path,
              title: tc(title),
              onAgree: function onAgree() {
                return __awaiter(this, void 0, void 0, function () {
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4, api.user.addAgreement({
                          statement_id: item.id
                        })];

                      case 1:
                        _a.sent();

                        store.dispatch('user/updateAgreementList');
                        callback && callback();
                        return [2];
                    }
                  });
                });
              }
            });
          }

          return [2, item];
      }
    });
  });
});